module.exports = __webpack_public_path__ + "img/img32.fec5e5b3.svg";